import React, { useEffect, useRef } from 'react';
import { Section } from 'components/shared';
import { useCountryValue } from 'stores/country';

import loadable from '@loadable/component';
const IconBlock = loadable(() =>
  import('components/components/organisms/IconBlock'),
);

const getColorClass = (textStyle = '') => {
  const bgColor = textStyle.split('-')[1];

  switch (bgColor) {
    case 'blue':
      const textColor = textStyle.split('-')[0];
      if (textColor === 'blue') {
        return 'bg-light-blue';
      }
      return 'bg-mattamy-blue';
    default:
      return 'bg-white';
  }
};

const ColumnsBlock = ({ fields = { value: [] }, rendering }) => {
  const data = fields.value[0];
  const [{ country }] = useCountryValue();

  const contentBlockRef = useRef();
  useEffect(() => {
    let current = contentBlockRef.current;
    if (current && country === 'CAN') {
      current.setAttribute('id', 'afteribuy');
    }
  }, []);

  if (!data) {
    return null;
  }

  const {
    subItemsBlock = [],
    numberColumns,
    title,
    titleStyle,
    text,
    textStyle,
  } = data;

  const filteredItems = subItemsBlock.filter((item) => item.title);

  const bgColorClass = getColorClass(textStyle);
  const { componentName } = rendering;

  return (
    <Section className={bgColorClass} ref={contentBlockRef}>
      <IconBlock
        items={filteredItems}
        numberColumns={numberColumns}
        title={title}
        titleStyle={titleStyle}
        text={text}
        textStyle={textStyle}
        buttonColor={
          bgColorClass !== 'bg-mattamy-blue' ? 'mattamy-blue' : 'white'
        }
        sectionId={componentName}
      />
    </Section>
  );
};

export default ColumnsBlock;
